(function () {
    'use strict';
    angular.module('GorillaBoy.directives')

        .directive('secondaryNav',
            ['$rootScope',
                'AuthService',
                'SessionManager',
                'SignalProvider',
                'RegionService',
                'LayoutManager',
                'focus',
                '$timeout',
                'SourceConstant',
                'AppConstants',
                'EndpointConfig',
                'EndpointService',
                'localStorageService',
                'OrganizationService',
                '$location',
                function ($rootScope, authService, SessionManager, SignalProvider, RegionService, LayoutManager, focus, $timeout, SourceConstant,
                          AppConstants, EndpointConfig, EndpointService, localStorageService, OrganizationService, location) {

                    return {
                        name: '=',
                        restrict: 'E',
                        templateUrl: './top-nav/secondary-nav.html',
                        transclude: true,
                        scope : true,
                        controller : 'NavController'
                    };
                }])
        .directive('searchFilters',
            ['$rootScope',
                'AuthService',
                'SessionManager',
                'SignalProvider',
                'RegionService',
                'LayoutManager',
                'focus',
                '$timeout',
                'SourceConstant',
                'AppConstants',
                'EndpointConfig',
                'EndpointService',
                'localStorageService',
                'OrganizationService',
                '$location',
                '$log',
                function ($rootScope, authService, SessionManager, SignalProvider, RegionService, LayoutManager, focus, $timeout, SourceConstant,
                          AppConstants, EndpointConfig, EndpointService, localStorageService, OrganizationService, location, $log) {

                    return {
                        name: '=',
                        restrict: 'E',
                        templateUrl: './top-nav/search_filters.html',
                        link: function (scope, element, attrs) {
                            $log.log("SEARCH FILTERS : Entered link function in Search Filters Directive");
                        }
                    };
                }])
        .directive('topNav', [
            '$rootScope',
            '$document',
            '$translate',
            '$routeParams',
            '$location',
            'FeatureManagerService',
            'TasksService',
            'SessionManager',
            'SignalProvider',
            'RegionService',
            'LayoutManager',
            'Features',
            '$timeout',
            '$uibModal',
            'SourceConstant',
            'AppConstants',
            'EndpointConfig',
            'EndpointService',
            'authenticatedUser',
            'QuerySearchManager',
            'ApprovalService',
            '$q',

            function ($rootScope, $document, $translate, $routeParams, $location, FeatureManagerService, TasksService, SessionManager, SignalProvider, RegionService, LayoutManager,
                      Features, $timeout, $uibModal, SourceConstant, AppConstants, EndpointConfig, EndpointService, authenticatedUser, QuerySearchManager, ApprovalService, $q) {

                var allNavItems = {};
                allNavItems.MY_DOCS = {name: $translate.instant('TOP_NAV.MYDOCS'), href: '#/mydocs', context: 'MY_DOCUMENTS'};
                allNavItems.FAVORITES = {name: $translate.instant('LEFT_NAV.FAVORITES'), href: '#/favorites', context: 'FAVORITES'};
                allNavItems.COLLABORATE = {name: $translate.instant('TOP_NAV.COLLABORATE'), href: '#/shared', context: 'COLLABORATE'};
                allNavItems.TASKS = {name: $translate.instant('TOP_NAV.TASKS'), href: '#/assignedTasks', context: 'TASKS'};
                allNavItems.ACTIVITIES = {name: $translate.instant('LEFT_NAV.ANALYTICS'), href: '#/activities', context: 'ACTIVITY_FEED'};


                return {
                    templateUrl: './top-nav/top_nav.html',
                    controller : 'NavController',
                    link: function (scope, element, attrs) {

                        var isSearchV2Enabled = FeatureManagerService.isFeatureEnabled(Features.UI.SEARCH_V2);
                        var isTaskEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.SHOW_TASKS);
                        // Get current folder ID from URL. Either when you're inside a folder: $routeParams.hasOwnProperty("folderId")
                        // or when user performed a search inside folder: $location.search().hasOwnProperty($scope.KEYWORDS.LOCATION)
                        var currentFolderIdURL = $routeParams.hasOwnProperty("folderId")? $routeParams.folderId : '';
                        var currentKeywordsOptionsValue = _.clone($location.search());
                        var KEYWORDS = QuerySearchManager.CONSTANTS.KEYWORDS;
                        currentKeywordsOptionsValue[KEYWORDS.LOCATION] = (currentKeywordsOptionsValue[KEYWORDS.LOCATION])?
                            currentKeywordsOptionsValue[KEYWORDS.LOCATION] : currentFolderIdURL;
                        var urlQuery = decodeURIComponent($location.search().query || '');
                        var queryString = ($routeParams.queryString)? $routeParams.queryString : '';

                        scope.searchInfo = {
                            query: (isSearchV2Enabled)? QuerySearchManager.translateQuery(urlQuery) : scope.sanitizeQuery(queryString),
                            currentFolderId: (isSearchV2Enabled)? currentKeywordsOptionsValue[KEYWORDS.LOCATION] : undefined,
                            urlQuery: (isSearchV2Enabled)? urlQuery : undefined
                        };

                        var userInfo = authenticatedUser.getUserInfo();
                        var notifyAdminModal = null;

                        scope.DEFAULT_PROFILE_ICON = 'images/default.png';
                        var unbindWatcherForCustomLogo = scope.$watch(
                            "clientLogoUrl",
                            function( url ) {
                                if (url) {
                                    changeLogo(url);
                                    unbindWatcherForCustomLogo();
                                }
                            }
                        );

                        scope.isTaskEnabled = function(){
                            if(authenticatedUser.getUserInfo().MinimalUser){
                                return false;
                            }

                            var featureEnabledState = FeatureManagerService.isFeatureEnabled(Features.UI.SHOW_TASKS) || false;
                            return featureEnabledState;
                        };

                        scope.showTaskBadge = function(){
                            // note: numberOfTasksAndApprovals is string
                            return $rootScope.numberOfTasksAndApprovals && $rootScope.numberOfTasksAndApprovals !== '0';
                        };

                        scope.isNewButtonVisible = function() {
                            return !authenticatedUser.getUserInfo().MinimalUser;
                        };

                        scope.isAppButtonVisible = function() {
                            return !authenticatedUser.getUserInfo().MinimalUser;
                        };

                        /**
                         * Fetches the number of Tasks and awaiting Approval Requests count
                         */
                        function getAssignedTaskNumber(){
                            var describeApprovalsPromise = $q.when({
                                ApprovalInfos : [],
                                Marker: null
                            });
                            if (FeatureManagerService.isFeatureEnabled(Features.UI.APPROVAL)) {
                                describeApprovalsPromise = ApprovalService.DescribeApprovals('ASSIGNED', null, null);
                            }
                            $q.all([describeApprovalsPromise,
                                TasksService.getAssignedTasks()])
                                .then(function(responses) {
                                    var approvalResponse = responses[0];
                                    var getTasksResponse = responses[1];

                                    var numberOfApprovals = approvalResponse.ApprovalInfos.length;
                                    $rootScope.numberOfApprovals = numberOfApprovals + "";
                                    if (approvalResponse.Marker) {
                                        if (numberOfApprovals <= 99) {
                                            $rootScope.numberOfApprovals = numberOfApprovals + '+';
                                        } else {
                                            $rootScope.numberOfApprovals = '99+';
                                        }
                                    }

                                    var numberOfTasks = getTasksResponse.Tasks.length;
                                    $rootScope.numberOfTasks = numberOfTasks + '';
                                    if (getTasksResponse.Marker) {
                                        if (numberOfTasks <= 99) {
                                            $rootScope.numberOfTasks += '+';
                                        } else {
                                            $rootScope.numberOfTasks = '99+';
                                        }
                                    }

                                    $rootScope.numberOfTasksAndApprovals = numberOfTasks + numberOfApprovals + '';
                                    //Since this service fetches the data to be shown in the top nav asynchronously, the count
                                    //actually flickers when navigating pages. That's why it's better to store in $rootScope.
                                    if (numberOfTasks + numberOfApprovals > 99)  {
                                        $rootScope.numberOfTasksAndApprovals = '99+';
                                    }
                                });
                        }

                        getAssignedTaskNumber();

                        function changeLogo(url) {
                            var $div = element.find(".workdocs-logo");
                            $div.css("background-image", "url('" + url + "')");
                        }

                        scope.navItemsForFullUser = [allNavItems.MY_DOCS, allNavItems.COLLABORATE, allNavItems.ACTIVITIES];
                        scope.navItemsForMinimalUser = [];
                        scope.navItemsForAnonymousSharee = [allNavItems.COLLABORATE];

                        scope.searchViewModel = {
                            isSearchMenuOpen : false
                        };

                        scope.isProfilePanelOpen = false;

                        if(scope.authenticated){
                            scope.navItems = (scope.isMinimalUser? scope.navItemsForMinimalUser :scope.navItemsForFullUser);
                        }else{
                            scope.navItems = scope.navItemsForAnonymousSharee;
                        }

                        scope.isFavoritesEnabled = function(){
                            var featureEnabledState = FeatureManagerService.isFeatureEnabled(Features.UI.FAVORITES) || false;
                            return featureEnabledState && !scope.isMinimalUser;
                        };

                        function closeProfilePanel() {
                            angular.element("#profile-panel").css("transform", "translate3d( 0, 0, 0)");
                            angular.element("#profile-panel").attr("open",false);
                            scope.isProfilePanelOpen = false;
                            angular.element('#avatar').focus();
                            $document.off('click', closeProfilePanelIfOpen);  // unregister listener if applicable
                            $document.off('keydown', closeProfilePanelOnEsc); // unregister listener if applicable
                        }

                        function closeProfilePanelIfOpen(event) {
                            var clickedElement = event.target;
                            var elementClasses = clickedElement.classList;
                            if (!clickedElement) return;

                            var clickedInsideProfilePanel = jQuery(clickedElement).parents('aside-menu').length > 0 || jQuery(clickedElement).is('aside-menu');

                            var clickedOnProfileWidget = elementClasses.contains('person-fullname') ||
                                elementClasses.contains('person-thumbnail') ||
                                (clickedElement.parentElement !== null && clickedElement.parentElement.hasAttribute('aside-menu-toggle'));

                            if (!clickedOnProfileWidget && !clickedInsideProfilePanel) {
                                closeProfilePanel();
                            }
                        }

                        function closeProfilePanelOnEsc(event) {
                            if (!scope.isProfilePanelOpen) {
                                return;
                            }
                            var KEYCODE_ESC = 27;
                            if (event.keyCode === KEYCODE_ESC) {
                                closeProfilePanel();
                            }
                        }

                        scope.toggleProfilePanel = function() {
                            scope.isProfilePanelOpen = !scope.isProfilePanelOpen;
                            if (scope.isProfilePanelOpen) {
                                // Focus on close-panel button after opening animation end.
                                angular.element('#profile-panel').on('transitionend', function() {
                                    angular.element('#profile-panel-done').focus();
                                    angular.element('#profile-panel').off('transitionend');
                                });

                                // put in timeout to register listener on the next digest loop to avoid
                                // closeProfilePanelIfOpen get called immediately.
                                $timeout(function() {
                                    $document.on('click', closeProfilePanelIfOpen);
                                    $document.on('keydown', closeProfilePanelOnEsc);
                                }, 0, false);
                            } else {
                                // Unregister listener to avoid UI break when double clicking avatar
                                angular.element('#profile-panel').off('transitionend');
                            }
                        };

                        scope.profilePictureKeyDown = function(event) {
                            var KEYCODE_ENTER = 13, KEYCODE_SPACE = 32;
                            if (event.keyCode === KEYCODE_ENTER || event.keyCode === KEYCODE_SPACE) {
                                scope.toggleProfilePanel();
                            }
                        };

                        scope.tabClickHandler = (itemName) => {
                            if(itemName === 'Collaborate'){
                                $rootScope.sharedTabLatencyMetric = $rootScope.metricServiceInstance.newLatencyMetric('Shared_Tab_Click_Load')
                            }
                            $rootScope.allTabsLatencyMetric = $rootScope.metricServiceInstance.newLatencyMetric('All_Tab_Click_Load')
                        };

                        var customClickEventDeRegFn = $rootScope.$on(SignalProvider.CustomClickEvent, function(event, eventArgs) {
                            if (scope.isProfilePanelOpen) {
                                closeProfilePanel();
                            }
                        });
                        scope.$on("$destroy", function() {
                            customClickEventDeRegFn();
                            $document.off('click', closeProfilePanelIfOpen);
                        });

                        scope.getProfilePhoto = function() {
                            return $rootScope.tmpImg ? $rootScope.tmpImg.dataURI : userInfo.ProfilePhotoMetadata.ProfilePhotoThumbnails.LARGE;
                        };

                        scope.showContactAdminModal = function() {
                            notifyAdminModal = $uibModal.open({
                                templateUrl: './tasks/contact_admin/contact_admin_task.html',
                                controller: 'ContactAdminTaskCtrl',
                            });
                        };

                        scope.appsButtonClickHandler = function() {
                            if ($rootScope.isFeatureEnabled($rootScope.Features.UI.INGRESS_MODAL)) {
                                var ingressModal = $uibModal.open({
                                    templateUrl: './shared/ingressModal/ingressModal.html',
                                    controller: 'ingressModalCtrl',
                                    size: 'lg',
                                });
                                scope.$on("$destroy", function() {
                                    ingressModal.close();
                                });
                            } else {
                                window.location.href = "https://amazonworkdocs.com/apps.html";
                            }
                            
                        };

                        scope.setSearchUrl = function(query, keywordsOptsVals) {

                            if (!isSearchV2Enabled) {
                                $location.url("/search/" + scope.sanitizeQuery(query));

                            } else {
                                var keywordsOptsValsUrl = "";
                                if (keywordsOptsVals && Object.keys(keywordsOptsVals).length > 0) {
                                    keywordsOptsValsUrl = "&" + $.param(keywordsOptsVals);
                                }

                                $location.url("/search/v2?query=" + encodeURIComponent(query) + keywordsOptsValsUrl);
                            }

                        };
                    }
                };
            }])

        .controller('NavController',
            ['$rootScope',
                '$translate',
                'AuthService',
                'SessionManager',
                'SignalProvider',
                'RegionService',
                'LayoutManager',
                'focus',
                '$timeout',
                'SourceConstant',
                'AppConstants',
                'EndpointConfig',
                'EndpointService',
                'localStorageService',
                'OrganizationService',
                '$location',


                '$scope',
                'authenticatedUser',
                '$log',
                'FileCountService',
                'Features',
                'FeatureManagerService', 'TasksService', 'UserService', 'ClientMetricsService', 'MetricEvents', '$window',

                NavController]);

    function NavController ($rootScope, $translate, authService, SessionManager, SignalProvider, RegionService, LayoutManager, focus, $timeout, SourceConstant,
                            AppConstants, EndpointConfig, EndpointService, localStorageService, OrganizationService, $location,
                            $scope, authenticatedUser, $log, FileCountService, Features, FeatureManagerService, TasksService, UserService,
                            ClientMetricsService, MetricEvents, $window) {

        function getContext(currentPage){
            switch(currentPage){
                case 'folder' :
                case 'document' :
                    return "SUB_FOLDER_OR_DOC";

                case "mydocs" :
                case "recycle" :
                case "recovery" :
                case "myNote" :
                case "hdriveMigration" :
                    return "MY_DOCUMENTS";

                case "favorites" :
                    return "MY_DOCUMENTS";

                case "shared" :
                case "feedback" :
                case "review" :
                case "sharedByMe" :
                    return "COLLABORATE";

                case "tasks" :
                case "assignedTasks" :
                case "archivedTasks" :
                case "yourApprovalRequests" :
                case "takenActionApprovals" :
                case "awaitingApproval" :
                    return "TASKS";

                case "activities" :
                    return "ACTIVITY_FEED";

                case 'search' :
                    return "SEARCH";

                default :
                    return "UNKNOWN";
            }
        }

        $scope.currentPage = $location.path().split('/')[1];
        $scope.context = getContext($scope.currentPage);
        $scope.authenticated = authService.isAuthenticated() && !$scope.layout.isAnonymous;
        // For anonymous share we have to check if user is null
        $scope.user = authenticatedUser.getUserInfo();

        //  $scope.secondaryNavItems = getSecondaryNavItems($translate, $scope.context, $scope.currentPage);


        // TODO: These all point towards the same icon until we have clearance to make grey versions of our logo
        $scope.DEFAULT_PROFILE_ICON = 'images/default.png';
        $scope.fileCounts = {};
        $scope.isPreviewSite = EndpointConfig.isPreviewSite();
        $scope.isAllowedStage = EndpointConfig.isAllowedStage();
        $scope.isMinimalUser = FeatureManagerService.isFeatureEnabled(Features.UI.EXTERNAL_SHARE) && $scope.user && $scope.user.MinimalUser;
        $scope.isBasicUser = $scope.user && ($scope.user.SkuType === AppConstants.SkuType.BASIC) ? true : false;

        $scope.downloadClientUrl = EndpointConfig.clientUrlDownload();
        $scope.feedbackPageUrl = EndpointConfig.feedbackPageUrl();
        $scope.helpPageUrl = EndpointConfig.HELP_PAGE_URL;
        $scope.forumPageUrl = EndpointConfig.FORUM_PAGE_URL;
        $scope.isAmazonSite = EndpointConfig.isAmazonSite();
        $scope.reportBugUrl = EndpointConfig.reportBugUrl();

        console.debug("SECONDARY_NAV_DIRECTIVE Controller.\n scope.context=" + $scope.context +
            "; \nscope.currentPage=" + $scope.currentPage +
            "; \nscope.authenticated=" + $scope.authenticated +
            "; \nscope.isMinimalUser=" + $scope.isMinimalUser
        );



        if ($scope.authenticated) {
            if ($rootScope.tmpImg) {
                var expirationTime = $rootScope.tmpImg.expirationTime;
                if (Date.now() - expirationTime > 0) {
                    $rootScope.tmpImg = null;
                }
            }
            $scope.smallPhoto = $rootScope.tmpImg ? $rootScope.tmpImg.dataURI : $scope.user.ProfilePhotoMetadata.ProfilePhotoThumbnails.SMALL + '&Timestamp=' + Date.now();
            $scope.administrator = $scope.user.Administrator;
            $scope.homeLink = '#/mydocs';
            $scope.fileCounts = FileCountService.getCounts();
            FileCountService.updateCounts()
                .then(function(d) {
                    $scope.fileCounts = d;
                });
        } else {
            $scope.administrator = false;
            $scope.homeLink = '#/login';
        }

        $scope.isMinimizedSearchOpen = false;
        $scope.keepSearchOpen = function() {
            $scope.isMinimizedSearchOpen = true;
        };
        $scope.$on(AppConstants.GB_SEARCH.SEARCH_SUBMITTED, function($event) {
            $scope.isMinimizedSearchOpen = false;
        });
        $scope.$on(AppConstants.GB_SEARCH.SEARCH_CLOSED, function($event) {
            $scope.isMinimizedSearchOpen = false;
        });

        $scope.clickHomeLink = function () {
            // Check the user authentication
            if (!authService.isAuthenticated()) {
                $scope.homeLink = '#/login';
                return;
            }

            $rootScope.showDocs();
        };

        $scope.refreshView = function(view) {
            if ($scope.folderState && $scope.folderState.view !== view) {
                $scope.$broadcast(SignalProvider.Folder.RequestSyncView, view);
            }
        };



        function logoutResultHandler (data) {
            // Clear the cookie based session.
            SessionManager.logout();
            // Navigate to the login page and clear the history.
            if (localStorageService.get(AppConstants.AuthType.AUTH_TYPE) == AppConstants.AuthType.AUTH_TYPE_LOGINV2) {
                // logout is managed by Loginv2 pages. So go there.
                $scope.redirectToLoginV2LogoutUrl();
            } else {
                $location.path('/login');
            }
        }

        $scope.logout = function () {
            authService.logout()
                .finally(logoutResultHandler);
        };

        /**
         * Go to loginv2's logout url if the user was authenticated using loginv2 flow.
         */
        $scope.redirectToLoginV2LogoutUrl = function() {
            var region, stage, appPrefix, logoutUrl, inPreview;
            region = RegionService.getRegion();
            stage = EndpointService.stageConfigKey(region);
            inPreview = localStorageService.get(AppConstants.PreviewSite.PREVIEW_STORAGE_KEY);
            appPrefix = EndpointService.appPrefix(stage, inPreview);

            // Define the logout url based on the stage, region and inPreview status.
            logoutUrl = EndpointService.loginV2LogoutUrl(stage, inPreview) + '?sitename=' + encodeURIComponent(EndpointService.organization());
            logoutUrl += '&site_redirect_path=' + encodeURIComponent(appPrefix + '/index.html#/authSuccess');

            $scope.changeWindowLocationHref(logoutUrl);
            return;
        };

        $scope.signUserForPreview = function() {
            UserService.updateUserPreferences(authenticatedUser.getUserInfo().Id, {'webVersion' : AppConstants.PreviewSite.WEB_PREVIEW_PREF}).then(function() {
                    // redirect to prod website
                    var absUrl  = $location.absUrl(),
                        redirectUrl;

                    redirectUrl = absUrl.replace(AppConstants.PreviewSite.PROD_URL_COMPONENT, AppConstants.PreviewSite.PREVIEW_URL_COMPONENT);
                    ClientMetricsService.addClickToSession(MetricEvents.USER_SIGNED_UP_PREVIEW + MetricEvents.ACTIONS.CLICK);

                    // update local storage
                    localStorageService.set(AppConstants.PreviewSite.PREVIEW_STORAGE_KEY, true);

                    $scope.changeWindowLocationHref(redirectUrl);
                },
                function(error) {
                    $log.error(new Date().toISOString() + ' [LoginController] Failed to update user preference from production to preview site');
                });
        };

        $scope.revertUserToProd = function(){
            UserService.updateUserPreferences(authenticatedUser.getUserInfo().Id, {'webVersion' : AppConstants.PreviewSite.WEB_PROD_PREF}).then(function() {
                    // redirect to beta website
                    var absUrl  = $location.absUrl(),
                        redirectUrl;

                    redirectUrl = absUrl.replace(AppConstants.PreviewSite.PREVIEW_URL_COMPONENT, AppConstants.PreviewSite.PROD_URL_COMPONENT);
                    ClientMetricsService.addClickToSession(MetricEvents.USER_SWITCHED_BACK_TO_PROD   + MetricEvents.ACTIONS.CLICK);

                    // update local storage
                    localStorageService.set(AppConstants.PreviewSite.PREVIEW_STORAGE_KEY, false);

                    $scope.changeWindowLocationHref(redirectUrl);
                },
                function(error) {
                    $log.error(new Date().toISOString() + ' [LoginController] Failed to update user preference from preview to production site');
                });
        };


        $scope.isAnalyticsDashboardEnabled = function() {
            // Set to false before code review
            var featureEnabledState = FeatureManagerService.isFeatureEnabled(Features.UI.ANALYTICS_DASHBOARD_LINK) || false;
            return featureEnabledState;
        };

        $scope.isMarketplaceLinkEnabled = function(){
            return (FeatureManagerService.isFeatureEnabled(Features.UI.MARKETPLACE_LINK) || false);
        };

        $scope.isSharedByMeEnabled = function(){
            return (FeatureManagerService.isFeatureEnabled(Features.UI.SHARED_BY_ME) || false);
        };

        $scope.isOnlineNoteEnabled = function() {
            return FeatureManagerService.isFeatureEnabled(Features.DocumentViewer.ONLINENOTES) && $rootScope.onlineEditingEnabled;
        };

        $scope.$on(SignalProvider.Sidebar.UpdateCounts, function () {
            FileCountService.updateCounts()
                .then(function(d) {
                    $scope.fileCounts = d;
                });
        });

        $scope.$on(SignalProvider.Sidebar.EmptyRecycleBin, function () {
            $scope.fileCounts.recycle = '';
        });

    }  // function NavController ends
}());
